import {
  IBillingBulkRun,
  IBillingBulkRunSearch,
  IBillingDetails,
  IBillingListItem,
  IBillingListSearch,
  IEditBillingPayload,
  IGenerateBilling,
} from "../../../types/master/billingInterface";
import { BillingActionTypes, BillingActions } from "../../actionTypes/master/billingActionTypes";

export const getBillingList = (payload: IBillingListSearch): BillingActionTypes => ({
  type: BillingActions.GET_BILLING_LIST,
  payload,
});

export const setBillingList = (billingList: IBillingListItem[]): BillingActionTypes => ({
  type: BillingActions.SET_BILLING_LIST,
  payload: billingList,
});

export const setBillingListPageCount = (payload: number): BillingActionTypes => ({
  type: BillingActions.SET_BILLING_LIST_PAGE_COUNT,
  payload,
});

export const generateBilling = (payload: IGenerateBilling): BillingActionTypes => ({
  type: BillingActions.GENERATE_BILLING,
  payload,
});

export const setGeneratedBilling = (payload: IBillingListItem | null): BillingActionTypes => ({
  type: BillingActions.SET_GENERATED_BILLING,
  payload,
});

export const getBillingDataById = (id: number | string): BillingActionTypes => ({
  type: BillingActions.GET_BILLING_DATA_BY_ID,
  payload: id,
});

export const setBillingDataById = (payload: IBillingDetails): BillingActionTypes => ({
  type: BillingActions.SET_BILLING_DATA_BY_ID,
  payload,
});

export const editBilling = (payload: IEditBillingPayload): BillingActionTypes => ({
  type: BillingActions.EDIT_BILLING_DATA_BY_ID,
  payload,
});

export const deleteBilling = (id: number | string): BillingActionTypes => ({
  type: BillingActions.DELETE_BILLING,
  payload: id,
});

export const getBillingHistory = (payload: IBillingBulkRunSearch): BillingActionTypes => ({
  type: BillingActions.GET_BILLING_HISTORY,
  payload,
});

export const setBillingHistory = (payload: IBillingBulkRun[]): BillingActionTypes => ({
  type: BillingActions.SET_BILLING_HISTORY,
  payload,
});

export const setBillingHistoryPageCount = (payload: number): BillingActionTypes => ({
  type: BillingActions.SET_BILLING_HISTORY_PAGE_COUNT,
  payload,
});

export const getBillingHistoryById = (id: number | string): BillingActionTypes => ({
  type: BillingActions.GET_BILLING_HISTORY_BY_ID,
  payload: id,
});

export const setBillingHistoryById = (payload: IBillingBulkRun | null): BillingActionTypes => ({
  type: BillingActions.SET_BILLING_HISTORY_BY_ID,
  payload,
});

export const clearBillingHistoryById = (): BillingActionTypes => ({
  type: BillingActions.CLEAR_BILLING_HISTORY_BY_ID,
});
